import { useNavigate } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import { Button } from '@/components/ui';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <div className="w-20 h-20 rounded-2xl bg-gray-100 flex items-center justify-center mx-auto mb-6 text-gray-400">
          <FileQuestion className="w-10 h-10" />
        </div>
        <h1 className="text-6xl font-bold text-gray-900 mb-2">404</h1>
        <p className="text-lg text-gray-500 mb-8">Страница не найдена</p>
        <Button onClick={() => navigate('/', { replace: true })}>
          На главную
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
